module.exports = __webpack_public_path__ + "img/thumb_35.7e96c8ef.jpg";